import { useTranslation } from 'react-i18next'
import { BaseDialog } from 'ui/src/components/Dialog/BaseDialog'

type EmptyFetchedInsurancesContentProps = {
  externalInsurerName: string
}

export function EmptyFetchedInsurancesContent({ externalInsurerName }: EmptyFetchedInsurancesContentProps) {
  const { t } = useTranslation('purchase-form')

  return <BaseDialog.Title>{t('CURRENT_INSURANCE_FETCH_FAILED_MESSAGE', { externalInsurerName })}</BaseDialog.Title>
}
